import React from 'react';
import PropTypes from 'prop-types';

const UserInfo = ({ value }) => (
  <div>
    <div className="a-text-heading">
      {`${value.firstName} ${value.lastName}`}
    </div>
    <div className="a-text-caption a-text-9e9">
      SSO: {value.sso}
    </div>
    <div className="a-text-caption font-weight-medium border-bottom a-border-light a-mt-10 a-mb-20 a-text-616">
      {value.email}
    </div>
  </div>
);

UserInfo.propTypes = {
  value: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    sso: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    receiveEmailFlag: PropTypes.string.isRequired,
    hideDecimalsFlag: PropTypes.string.isRequired,
    negativeMinusFlag: PropTypes.string.isRequired,
    displayZeroFlag: PropTypes.string.isRequired,
    shadeGridFlag: PropTypes.string.isRequired,
  }).isRequired,
};

export default UserInfo;
